/**
 * ⚠️  AUTO-GENERATED — DO NOT EDIT MANUALLY ⚠️
 *
 * Generated by: scripts/preload-query-batch-classifier/index.mjs
 *
 * Per-region SSR preloaded GraphQL query classification using bitmap encoding.
 * Q contains all query names (sorted, with index comments). R maps each SSR
 * region to a hex bitmap where bit i = 1 means Q[i] is fast (batchable).
 *
 * Per-region classification summary (fast/slow/excluded counts) is
 * embedded in the PR description.
 *
 * Thresholds: p90 ≤ 300ms | p95 ≤ 500ms | p99 ≤ 1000ms | min n=100
 * Lookback: last 3 business days
 * Generated: 2026-04-29T21:37:53.966Z
 */

declare const __SSR_REGION__: string | undefined;

// prettier-ignore
const Q: readonly string[] = [
	'ActiveCommentsQuery', // 0
	'ApprovalsContextApprovalsDataQuery', // 1
	'ArchivedPageBannerV2ArchivedPageBannerContainerQuery', // 2
	'ArchivedPageBannerV2ArchivedPageBannerQuery', // 3
	'BlogTreeRootComponentQuery', // 4
	'CollabDraftQuery', // 5
	'CollabDraftWithRelevanceQuery', // 6
	'ContentBlogUnifiedQuery', // 7
	'ContentHeaderPresenceContentSettingsQuery', // 8
	'ContentHeaderUnifiedQuery', // 9
	'ContentPrerequisitesQuery', // 10
	'ContentRedirectQuery', // 11
	'ContentTypesHeaderQuery', // 12
	'ContentUnifiedQuery', // 13
	'ContentUnifiedWithSpaceKeyQuery', // 14
	'CookieConsentPreferences', // 15
	'CoverPictureQuery', // 16
	'CustomHeaderFooterQuery', // 17
	'DatabaseContainerQuery', // 18
	'EditContentButtonQuery', // 19
	'EditorContentStateQuery', // 20
	'EditorPreferencesQuery', // 21
	'EmojiTitleQuery', // 22
	'EndOfPageRecommendationQuery', // 23
	'FooterCreateButtonsQuery', // 24
	'ForgeExtensionList', // 25
	'GrantAccessDialogLoaderQuery', // 26
	'InlineCommentsFocusedInlineCommentQuery', // 27
	'LegacyMacroRendererQueryBodyQuery', // 28
	'LivePagesByLineLastUpdatedQuery', // 29
	'LocalStorageQuery', // 30
	'NativeCollabQuery', // 31
	'NotFoundContainerQuery', // 32
	'ObjectCommentContainerPreloadObjectCommentsQuery', // 33
	'PageRestrictionsContextQuery', // 34
	'PageTreeQuery', // 35
	'PageTreeQueryWithSpaceKeyQuery', // 36
	'PermissionCheckAddCommentQuery', // 37
	'PersistentInviteEligibleQuery', // 38
	'PersonalizedTemplatesV2AllTemplatesQuery', // 39
	'Preferences', // 40
	'ReactionsContentQuery', // 41
	'RecentlyUpdatedMacroQuery', // 42
	'RendererContentStateQuery', // 43
	'RestrictedPageWithCanViewQuery', // 44
	'ScreenQuery', // 45
	'SiteInformationQuery', // 46
	'SmartCreateFeedbackBannerQuery', // 47
	'SmartCreatePageEditorDataWrapperComponentQuery', // 48
	'SpaceNavigationQuery', // 49
	'SpaceOverviewIdQuery', // 50
	'SpaceOverviewQuery', // 51
	'SpaceQuery', // 52
	'SpaceRestrictionCheckQuery', // 53
	'ThemeQuery', // 54
	'TopNavigationQuery', // 55
	'UserSettingsQuery', // 56
	'ViewSpaceExternalCollaboratorsDialogQuery', // 57
	'WebItemLocationQuery_page.metadata.banner', // 58
	'WebItemLocationQuery_system.content.byline', // 59
	'WebItemLocationQuery_system.header_left', // 60
	'WebItemLocationQuery_system.header_left_system.user', // 61
	'WebPanelLocationQuery_atl.footer', // 62
	'WebPanelLocationQuery_atl.general', // 63
	'WebPanelLocationQuery_atl.general_atl.footer', // 64
	'WebPanelLocationQuery_atl.page.content.footer.actions', // 65
	'WebStorageCategories', // 66
	'WelcomeMessagesQuery', // 67
	'WhiteboardUnifiedQuery', // 68
	'agg_ArchivedPageBannerV2ArchivedPageBannerContainerQuery', // 69
	'agg_BlogTreeRootComponentQuery', // 70
	'agg_CollabDraftQuery', // 71
	'agg_ContentBlogUnifiedQuery', // 72
	'agg_ContentHeaderPresenceContentSettingsQuery', // 73
	'agg_ContentHeaderUnifiedQuery', // 74
	'agg_ContentUnifiedQuery', // 75
	'agg_ContentUnifiedWithSpaceKeyQuery', // 76
	'agg_CoverPictureQuery', // 77
	'agg_CustomHeaderFooterQuery', // 78
	'agg_EditContentButtonQuery', // 79
	'agg_EditorContentStateQuery', // 80
	'agg_EmojiTitleQuery', // 81
	'agg_EndOfPageRecommendationQuery', // 82
	'agg_FetchPreFilteredForgeAppsQuery_confluence_contentBylineItem', // 83
	'agg_FetchPreFilteredForgeAppsQuery_confluence_spacePage', // 84
	'agg_FetchPreFilteredForgeAppsQuery_xen_macro', // 85
	'agg_FollowingFeedWithSortByStorageSnippetsQuery', // 86
	'agg_FooterCreateButtonsQuery', // 87
	'agg_GlobalNavigationComponentQuery', // 88
	'agg_HomeRecentWorkQuery', // 89
	'agg_LivePagesByLineLastUpdatedQuery', // 90
	'agg_NativeCollabQuery', // 91
	'agg_NotificationsButtonQuery', // 92
	'agg_PageRestrictionsContextQuery', // 93
	'agg_PageTreeQuery', // 94
	'agg_PageTreeQueryWithSpaceKeyQuery', // 95
	'agg_PersistentInviteEligibleQuery', // 96
	'agg_PersonalizedTemplatesV2AllTemplatesQuery', // 97
	'agg_PopularFeedWithTimeGranularityStorageSnippetsQuery', // 98
	'agg_PremiumTrialEotQuery', // 99
	'agg_ReactionsContentQuery', // 100
	'agg_RendererContentStateQuery', // 101
	'agg_RestrictedPageWithCanViewQuery', // 102
	'agg_ScreenQuery', // 103
	'agg_SiteInformationQuery', // 104
	'agg_SmartCreateFeedbackBannerQuery', // 105
	'agg_SpaceNavigationQuery', // 106
	'agg_SpaceOverviewQuery', // 107
	'agg_ThemeQuery', // 108
	'agg_TopNavigationQuery', // 109
	'agg_UserSettingsQuery', // 110
	'agg_ViewSpaceExternalCollaboratorsDialogQuery', // 111
	'agg_WebItemLocationQuery_system.content.byline', // 112
	'agg_WebItemLocationQuery_system.header_left', // 113
	'agg_WebPanelLocationQuery_atl.footer', // 114
	'agg_WebPanelLocationQuery_atl.general', // 115
	'agg_WebPanelLocationQuery_atl.page.content.footer.actions', // 116
	'agg_WelcomeMessagesQuery', // 117
	'agg_contentAppearanceQuery', // 118
	'agg_fetchMentionsProviderDataQuery', // 119
	'agg_graphqlHelpersFetchMediaTokenQuery', // 120
	'agg_multiMacroQueryQuery', // 121
	'agg_onboardingStateGetOnboardingStateQuery', // 122
	'agg_onboardingStateGetOnboardingStateQuery_aifc-onboarding_hasSeenAIFCSpotlight_8', // 123
	'agg_onboardingStateGetOnboardingStateQuery_auto-page-emoji_emojiTitleDiscovered', // 124
	'agg_onboardingStateGetOnboardingStateQuery_create-with-rovo-announcement-splash_hasSeenSplashModal', // 125
	'agg_onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_2', // 126
	'agg_onboardingStateGetOnboardingStateQuery_editor-state_editorOnboardingEligiblity_12', // 127
	'agg_onboardingStateGetOnboardingStateQuery_land-users-in-editor-with-revamped-bpqa_revampedBpqaShownAt', // 128
	'agg_onboardingStateGetOnboardingStateQuery_onboarding-intent-experiences_onboardingIntentExperienceClosed_18', // 129
	'agg_onboardingStateGetOnboardingStateQuery_onboarding-intent-experiences_onboardingIntentExperienceClosed_22', // 130
	'agg_onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_10', // 131
	'agg_onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_6', // 132
	'agg_onboardingStateGetOnboardingStateQuery_onboarding-state_nthUserOnboardingCompletedTimestamp', // 133
	'agg_preloadAutohighlightsQuery', // 134
	'agg_preloadContentSmartLinksQuery', // 135
	'agg_preloadCreateSpaceQuery', // 136
	'agg_preloadEditButtonWithSpaceKeyQuery', // 137
	'agg_preloadEditorNodeDataProvidersDataQuery', // 138
	'agg_preloadLegacyBridgeQuery', // 139
	'agg_preloadOperationsQuery', // 140
	'agg_preloadPageStatusQueryDataQuery', // 141
	'agg_preloadPersonalSpaceDetailsQuery', // 142
	'agg_preloadTemplatesCollectionEligibleQuery', // 143
	'agg_useAnalyticsByLineQuery', // 144
	'agg_useAudioContentQuery', // 145
	'agg_useConfluenceStandardToPremiumExperimentQuery', // 146
	'agg_useContentClassificationContentDataClassificationQuery', // 147
	'agg_useEmojiEverSetPropertyQuery', // 148
	'agg_useFabricEligibilityMigrationQuery', // 149
	'agg_useFeatureDiscoveryFeatureDiscoveryQuery', // 150
	'agg_useFeedTypeSelectorRefreshQuery', // 151
	'agg_useFollowingFeedWithSortByStorageFeedContentQuery', // 152
	'agg_useGetTeamAndSubanchorGetPersonalSpaceKeyQuery', // 153
	'agg_useGetTeamAndSubanchorGetSubanchorsAGGQuery', // 154
	'agg_useHomeWidgetStateQuery', // 155
	'agg_useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery', // 156
	'agg_useIsLoomEntryPointsEnabledQuery', // 157
	'agg_useLicensedProductsQueryForGlobalAppShortcutsQuery', // 158
	'agg_useLoomTenantProvisionStatusQuery', // 159
	'agg_usePopularFeedWithTimeGranularityStorageQuery', // 160
	'agg_usePreloadCommentButtonQuery', // 161
	'agg_useReadTimeQuery', // 162
	'agg_useRegisterAdminAnnouncementBannerQuery', // 163
	'agg_useShortcutsSpaceNavigationQuery', // 164
	'agg_useSpaceBaseQueryBaseQuery', // 165
	'agg_useSpaceDetailQuery', // 166
	'agg_useSpaceViewsDataSpaceRootQuery', // 167
	'agg_useSpaceViewsOptionsPersistenceQuery', // 168
	'agg_useSpacesDataMyVisitedSpacesQuery', // 169
	'agg_useSpacesDataStarredSpacesQuery', // 170
	'agg_useTitleContentPropertiesForEditorQuery', // 171
	'agg_useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery', // 172
	'agg_useTitleContentPropertiesForPublishedPageQuery', // 173
	'agg_useUserByLicensedProductsQuery', // 174
	'contentAppearanceQuery', // 175
	'contentSmartLinksORS', // 176
	'fetchMentionsProviderDataQuery', // 177
	'graphqlHelpersDSPIsActionEnabledForContentQuery', // 178
	'graphqlHelpersFetchMediaTokenQuery', // 179
	'multiMacroQueryWithAppKeyQuery', // 180
	'onboardingStateGetOnboardingStateQuery', // 181
	'onboardingStateGetOnboardingStateQuery_aifc-onboarding_hasSeenAIFCSpotlight_8', // 182
	'onboardingStateGetOnboardingStateQuery_auto-page-emoji_emojiTitleDiscovered', // 183
	'onboardingStateGetOnboardingStateQuery_create-with-rovo-announcement-splash_hasSeenSplashModal', // 184
	'onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_4', // 185
	'onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_6', // 186
	'onboardingStateGetOnboardingStateQuery_editor-state_editorOnboardingEligiblity_12', // 187
	'onboardingStateGetOnboardingStateQuery_land-users-in-editor-with-revamped-bpqa_revampedBpqaShownAt', // 188
	'onboardingStateGetOnboardingStateQuery_onboarding-intent-experiences_onboardingIntentExperienceClosed_18', // 189
	'onboardingStateGetOnboardingStateQuery_onboarding-intent-experiences_onboardingIntentExperienceClosed_22', // 190
	'onboardingStateGetOnboardingStateQuery_onboarding-origin-state_attributes_67', // 191
	'onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin', // 192
	'onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_10', // 193
	'onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_5', // 194
	'onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_6', // 195
	'onboardingStateGetOnboardingStateQuery_onboarding-state_nthUserGSPagePath_6', // 196
	'onboardingStateGetOnboardingStateQuery_onboarding-state_nthUserOnboardingCompletedTimestamp', // 197
	'onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_150', // 198
	'onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_151', // 199
	'onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_152', // 200
	'onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_156', // 201
	'pageButtons', // 202
	'preloadContentSmartLinksQuery', // 203
	'preloadCreateSpaceQuery', // 204
	'preloadEditButtonWithSpaceKeyQuery', // 205
	'preloadEditorNodeDataProvidersDataQuery', // 206
	'preloadLegacyBridgeQuery', // 207
	'preloadOperationsQuery', // 208
	'preloadPageStatusQueryDataQuery', // 209
	'preloadPersonalSpaceDetailsQuery', // 210
	'preloadShareAndRestrictButtonQuerySpaceOverviewQuery', // 211
	'preloadSpaceBlogCountQuery', // 212
	'preloadTemplatesCollectionEligibleQuery', // 213
	'requireSuperBatchFrontendResourceRenderQuery', // 214
	'rightPanel', // 215
	'searchCombinedConfig', // 216
	'searchResults', // 217
	'sidenavSmartLinksORS', // 218
	'useAnalyticsByLineQuery', // 219
	'useAudioContentQuery', // 220
	'useBlogPostsQueryQuery', // 221
	'useConfluenceStandardToPremiumExperimentQuery', // 222
	'useContentClassificationContentDataClassificationQuery', // 223
	'useContributorsDataQuery', // 224
	'useEditorContentModeValueQuery', // 225
	'useEmojiEverSetPropertyQuery', // 226
	'useFabricEligibilityMigrationQuery', // 227
	'useFeatureDiscoveryFeatureDiscoveryQuery', // 228
	'useFeedTypeSelectorRefreshQuery', // 229
	'useFollowingFeedWithSortByStorageFeedContentQuery', // 230
	'useGetCurrentStorageUsageQuery', // 231
	'useGetTeamAndSubanchorGetPersonalSpaceKeyQuery', // 232
	'useHomeWidgetStateQuery', // 233
	'useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery', // 234
	'useIsUserViewingSpaceAsAnonQuery', // 235
	'useLicensedProductsQueryForGlobalAppShortcutsQuery', // 236
	'useLoomTenantProvisionStatusQuery', // 237
	'usePopularFeedWithTimeGranularityStorageQuery', // 238
	'usePreloadCommentButtonQuery', // 239
	'useReadTimeQuery', // 240
	'useRegisterAdminAnnouncementBannerQuery', // 241
	'useShareAndRestrictButtonDataQuery', // 242
	'useShortcutsSpaceNavigationQuery', // 243
	'useSpaceBaseQueryBaseQuery', // 244
	'useSpaceDetailQuery', // 245
	'useSpaceEnabledContentTypesQuery', // 246
	'useSpaceViewsDataSpaceRootQuery', // 247
	'useSpaceViewsOptionsPersistenceQuery', // 248
	'useSpacesDataAnonymousSpacesQuery', // 249
	'useSpacesDataMyVisitedSpacesQuery', // 250
	'useSpacesDataStarredSpacesQuery', // 251
	'useTitleContentPropertiesForEditorQuery', // 252
	'useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery', // 253
	'useTitleContentPropertiesForPublishedPageQuery', // 254
	'useUserByLicensedProductsQuery', // 255
];

// prettier-ignore
const R: Readonly<Record<string, string>> = {
	'prod-apne': '9dff7bebbdf9ffff1200381308000000400000240080febf7fff8fda3ebbff79', /* 129 fast, 18 slow, 73 excl */
	'prod-apne2': 'f5ff7befbdf9ffff1200381108000000400000240080fe9ff7ff9bdabebbff79', /* 130 fast, 21 slow, 87 excl */
	'prod-apse': 'ddff7befbdfbffff1600381308000000400000240080fe9fffffdfdabebbff7b', /* 137 fast, 18 slow, 115 excl */
	'prod-apse2': 'fdff7befbdfbffff1e00381108000000400000240080feffffffffda3ebbffff', /* 142 fast, 14 slow, 83 excl */
	'prod-apsouth': 'd5fffbfbbdfbffff1a00381108000000400000240080feffffffbfdababbfffd', /* 138 fast, 12 slow, 13 excl */
	'prod-cacentral': 'bdff7bfbfdfbffff1e00381308000000400000240080feffffffbfdabebffffd', /* 143 fast, 8 slow, 10 excl */
	'prod-east': 'fdff7feffdfbffff1e00381308000000400000240080feffffffffdabebfffff', /* 147 fast, 10 slow, 160 excl */
	'prod-eucentral': 'bfff7fefbdfbffff1600381308000000400000240080febfffffffd2bebbff7b', /* 140 fast, 18 slow, 170 excl */
	'prod-eucentral2': 'bddf7bebbdfbfeff1200381008000000400000240080ee9fffff2fd0beb9ff7d', /* 125 fast, 23 slow, 10 excl */
	'prod-euwest': 'ffff7feffdfbffff1e00381308000000400000240080feffffffbfd2bebffffb', /* 145 fast, 12 slow, 174 excl */
	'prod-euwest2': 'fdff7beffdfbffff1a00381308000000400000240080feffffffbfdabebffffd', /* 143 fast, 9 slow, 82 excl */
	'prod-west2': '9dff7feffdfbffff1e00381308000000400000240080feffffffffdabebfffff', /* 145 fast, 11 slow, 140 excl */
	'stg-east': '0080000000010000040008100031024840114044080400218001000000000000', /* 23 fast, 206 slow, 67 excl */
	'stg-local': '0000000000000000000000000000000000000000000000000000000000000000', /* 0 fast, 0 slow, 71 excl */
};

const _cache = new Map<string, ReadonlySet<string>>();

function _decode(region: string): ReadonlySet<string> {
	const cached = _cache.get(region);
	if (cached) return cached;
	const hex = R[region];
	if (!hex) return _empty;
	const set = new Set<string>();
	for (let i = 0; i < Q.length; i++) {
		// eslint-disable-next-line no-bitwise
		const byteIdx = i >> 3;
		// eslint-disable-next-line no-bitwise
		const bitIdx = i & 7;
		const byte = parseInt(hex.slice(byteIdx * 2, byteIdx * 2 + 2), 16);
		// eslint-disable-next-line no-bitwise
		if (byte & (1 << bitIdx)) set.add(Q[i]);
	}
	const frozen = Object.freeze(set) as ReadonlySet<string>;
	_cache.set(region, frozen);
	return frozen;
}

const _empty: ReadonlySet<string> = Object.freeze(new Set<string>());
const _aggPrefix = 'agg_';

function _getEquivalentQueryName(queryName: string): string {
	return queryName.startsWith(_aggPrefix)
		? queryName.slice(_aggPrefix.length)
		: `${_aggPrefix}${queryName}`;
}

/**
 * Check whether a preload query is classified as fast (batchable) for the
 * current SSR region.
 *
 * @param queryName — the GraphQL operation name.
 * @param region — SSR region override; defaults to window.__SSR_REGION__.
 */
export function isFastPreloadQuery(
	queryName: string,
	region: string = typeof __SSR_REGION__ !== 'undefined' ? __SSR_REGION__ : '',
): boolean {
	const fastQueries = _decode(region);
	return fastQueries.has(queryName) || fastQueries.has(_getEquivalentQueryName(queryName));
}
